import useDropdownContext from '../../dropdown-context';
import { isMobileDisplay } from '~/helpers/device';
import { assertDefined } from '~/helpers/data';
function findNext(dropdownRef) {
    var _a;
    const targets = Array.from(assertDefined((_a = dropdownRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('a')));
    const idx = targets.indexOf(document.activeElement);
    const nextIdx = (idx + 1) % targets.length;
    return targets[nextIdx];
}
function findPrev(topRef, dropdownRef) {
    var _a;
    const targets = Array.from(assertDefined((_a = dropdownRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('a')));
    const idx = targets.indexOf(document.activeElement);
    if (idx === 0) {
        return topRef.current;
    }
    const prevIdx = (idx + targets.length - 1) % targets.length;
    return targets[prevIdx];
}
export default function useNavigateByKey({ topRef, dropdownRef, closeMenu, closeDesktopMenu }) {
    const { activeDropdown } = useDropdownContext();
    // eslint-disable-next-line complexity
    function navigateByKey(event) {
        var _a, _b, _c;
        if (isMobileDisplay()) {
            if (event.key === 'Escape' && activeDropdown.current) {
                const focusReturnsTo = activeDropdown.current;
                closeMenu();
                focusReturnsTo.focus();
                event.stopPropagation();
            }
            if (event.key.startsWith('Arrow') ||
                ['Home', 'End'].includes(event.key)) {
                event.preventDefault();
            }
            return;
        }
        switch (event.key) {
            case 'ArrowDown':
                event.preventDefault();
                if (document.activeElement === topRef.current) {
                    (_b = (_a = dropdownRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('a')) === null || _b === void 0 ? void 0 : _b.focus();
                }
                else {
                    findNext(dropdownRef).focus();
                }
                break;
            case 'ArrowUp':
                event.preventDefault();
                if (document.activeElement !== topRef.current) {
                    (_c = findPrev(topRef, dropdownRef)) === null || _c === void 0 ? void 0 : _c.focus();
                }
                break;
            case 'Escape':
                event.preventDefault();
                event.stopPropagation();
                event.target.blur();
                closeDesktopMenu();
                break;
            default:
                break;
        }
    }
    return navigateByKey;
}
